import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHealthRelationStart,
  getHealthRelationSuccess,
  getHealthRelationFailure,
} from "../reducers/getHealthRelationReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHealthRelation = createAsyncThunk(
  "getHealthRelation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHealthRelationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Health/GetRelation`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHealthRelationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHealthRelationFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
